var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description-list",style:({'max-width': _vm.maxWidth})},[(_vm.title)?_c('div',{staticClass:"description-list__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('a-row',_vm._b({},'a-row',_vm.$props,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }